export const UMB_CURRENT_USER_GROUP_ID_CONDITION_ALIAS = 'Umb.Condition.CurrentUser.GroupId';
